import type { ReactNode } from 'react';

import { Colors, Spacing } from '@treneo/shared/themes';
import { Box, styled } from '@treneo/shared/ui';

import { NavbarCenter, NavbarDivider, NavbarLeft, NavbarRight } from './navbar.styles';

const DefaultWrapper = styled(Box)`
  display: flex;
  margin-bottom: 10px;
  background: ${Colors.white};
  position: relative;
  height: 76px;
  align-items: center;
  &:before {
    content: '';
    background: ${Colors.white};
    position: absolute;
    height: 100%;
    width: 100vw;
    z-index: -1;
    margin: 0 calc(-50vw + 50%);
  }
` as typeof Box;

const AdminWrapper = styled(Box)`
  display: flex;
  flex-shrink: 0;
  margin-bottom: 10px;
  background: ${Colors.white};
  position: relative;
  height: 76px;
  align-items: center;
  width: 100%;
  padding-left: ${Spacing.large};
  padding-right: ${Spacing.large};
  &:before {
    content: '';
    background: ${Colors.white};
    position: absolute;
    height: 100%;
    width: 100vw;
    z-index: -1;
    margin: 0 calc(-50vw + 50%);
  }
` as typeof Box;

type BaseNavbarProps = {
  leftContent: ReactNode;
  centerContent?: ReactNode | null;
  rightContent: ReactNode;
  variant?: 'default' | 'admin';
};

export const BaseNavbar = ({
  leftContent,
  centerContent,
  rightContent,
  variant = 'default'
}: Readonly<BaseNavbarProps>) => {
  const Wrapper = variant === 'admin' ? AdminWrapper : DefaultWrapper;

  return (
    <Wrapper>
      <NavbarDivider>
        <NavbarLeft>{leftContent}</NavbarLeft>

        {centerContent && <NavbarCenter>{centerContent}</NavbarCenter>}

        <NavbarRight>{rightContent}</NavbarRight>
      </NavbarDivider>
    </Wrapper>
  );
};
